import React, { useState, useEffect } from "react";
import { useSelector, useDispatch, connect } from "react-redux";
import * as actionTypes from "../../../store/actions/actionTypes";

import axios from "axios";
import { server } from "../../../utills/utils";

import styled from "styled-components";

import HomeImg from "../../../assets/shopdefault.png";

const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
`;
const CoverImg = styled.img`
  width: 100%;
  height: 380px;
  border-radius: 5px;
`;

const ShopCards = styled.div`
  width: 100%;
  height: 150px;
  margin-top: 20px;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
`;
const Card1 = styled.div`
   {
    width: 31%;
    height: 100%;
    background: #ff7e7e;
    border-radius: 5px;
  }
`;
const Card2 = styled.div`
   {
    width: 31%;
    height: 100%;
    background: #b17dff;
    border-radius: 5px;
  }
`;
const Card3 = styled.div`
   {
    width: 31%;
    height: 100%;
    background: #bae52a;
    border-radius: 5px;
  }
`;
const CardValue = styled.h1`
  margin: 0;
  padding: 7% 0 4% 7%;
  color: white;
  font-size: 1.5em;
`;
const CardName = styled.p`
  margin: 0;
  padding: 0 7%;
  font-size: 1.2em;
  color: white;
`;

function Home(props) {
  const [shops, setShops] = useState(0);
  const [products, setProducts] = useState(0);
  const [customers, setCustomers] = useState(0);

  // const currentHome = useSelector((state) => state.utils);
  // console.log("Current home", currentHome);
  // const dispatch = useDispatch();

  const fetchHome = async () => {
    try {
      const home = await axios.post(server, {
        query: `
                         query{
                             adminHome{
                                 products
                                 shops
                                 customers
                                 activeShops,
                                 requestedShops,
                                 subOfShops,
                                 blcokedShops
                             }
                         }
                     `,
      });
      // console.log("Home ", home);
      // setShops(home.data.data.adminHome.shops);
      // setProducts(home.data.data.adminHome.products);
      // setCustomers(home.data.data.adminHome.customers);
      props.setAdminHome(home.data.data.adminHome);
      // dispatch(allActions.console.log("All Actions", allActions);
    } catch (error) {
      throw error;
    }
  };
  useEffect(() => {
    fetchHome();
  }, []);
  return (
    <Container>
      <CoverImg src={HomeImg} alt="cover" />
      <ShopCards>
        <Card1>
          <CardValue>{props.adminHome.shops}</CardValue>
          <CardName>Shops</CardName>
        </Card1>
        <Card2>
          <CardValue>{props.adminHome.products}</CardValue>
          <CardName>Products</CardName>
        </Card2>
        <Card3>
          <CardValue>{props.adminHome.customers}</CardValue>
          <CardName>Customers</CardName>
        </Card3>
      </ShopCards>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    adminHome: state.utils.adminHome,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setAdminHome: (adminData) => {
      dispatch({
        type: actionTypes.SET_ADMIN_HOME,
        adminData,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
